import { createStyles } from '@mui/styles';

export default () =>
  createStyles({
    root: {
    },
  });
